import onboarding1 from '../../../assets/img/remoteControl/onboarding/onboarding1.png';
import onboarding2 from '../../../assets/img/remoteControl/onboarding/onboarding2.png';
import onboarding3 from '../../../assets/img/remoteControl/onboarding/onboarding3.png';
import onboarding4 from '../../../assets/img/remoteControl/onboarding/onboarding4.png';

export type Step = {
  title: string;
  description: string;
  imgPath: string;
}

export const steps: Step[] = [
  {
    description: 'onboardingControle1Descricao',
    imgPath: onboarding1,
    title: 'onboardingControle1Titulo',
  },
  {
    description: 'onboardingControle2Descricao',
    imgPath: onboarding2,
    title: 'onboardingControle2Titulo',
  },
  {
    description: 'onboardingControle3Descricao',
    imgPath: onboarding3,
    title: 'onboardingControle3Titulo',
  },
  {
    description: 'onboardingControle4Descricao',
    imgPath: onboarding4,
    title: 'onboardingControle4Titulo',
  },
];

export const TOTAL_STEPS = steps.length;
